import React, { useState } from "react";
import { RiCloseLine } from "react-icons/ri"; // assuming you meant 'RiCloseLine' instead of 'RxCross2'

function HoaNotification() {
    const [showNotification, setShowNotification] = useState(true);

    const handleCloseNotification = () => {
        setShowNotification(false);
    };

    return (
        <>
            {showNotification && (
                <div className="bg-blue-800 flex justify-between w-full">
                    <div className="w-full flex justify-center items-center text-center">
                        <p className="py-[30px] px-[30px] text-base sm:text-base md:text-xl lg:text-[26px] font-medium text-white m-0">
                            News & Updates: We are launching on 4th of July.
                        </p>
                    </div>
                    <div className="w-[10%] sm:w-[10%] md:w-[10%] lg:w-[20%] flex justify-center items-center text-center" onClick={handleCloseNotification}>
                        <RiCloseLine className="text-white text-[22px] sm:text-[22px] md:text-[25px] lg:text-[30px] cursor-pointer" />
                    </div>
                </div>
            )}
        </>
    );
}

export default HoaNotification;